import { useEvent } from 'tamagui'
import { randomUUID } from '@/src/common/utils/randomUUID'
import { usePointsToStatementCredit } from './usePointsToStatementCredit'

export interface PresetRedemptionConfig {
  creditAmount: number
  dollarsPerPointConversion: number
  remainingPoints: number | 'loading'
}

export function usePresetRedemption() {
  const {
    setPointsToRedeem,
    setCreditAmount,
    setConversionRate,
    setRemainingPoints,
    setIdempotencyKey,
    clear,
  } = usePointsToStatementCredit()

  const preparePresetRedemption = useEvent(
    ({ creditAmount, dollarsPerPointConversion, remainingPoints }: PresetRedemptionConfig) => {
      const pointsToRedeem = Math.floor(creditAmount / dollarsPerPointConversion)

      clear()
      setPointsToRedeem(pointsToRedeem.toString())
      setConversionRate(dollarsPerPointConversion.toString())
      setCreditAmount(creditAmount.toString())
      setRemainingPoints(typeof remainingPoints === 'number' ? remainingPoints.toString() : '0')
      setIdempotencyKey(randomUUID())
    },
  )

  return {
    preparePresetRedemption,
  }
}
